import React, { useEffect, useState } from "react";
import SettingsEmptyState from './SettingsEmptyState';
import {
  ConfirmDelete,
  MwInputText,
  MwSpinner,
  MwSpinnerButton,
} from "../ui";
import { IoMdAdd } from "react-icons/io";

import MwSelectorAccount from "../ui/MwSelectorAccount";
import { useTranslation } from "react-i18next";
import { AiOutlineDelete } from "react-icons/ai";
import { useCurrent, useDelete, useFetch, usePost, usePut } from "../../hooks";
import { NewButton } from "../ui/NewButton";
import { BiSolidMessageSquareEdit } from "react-icons/bi";
import { NewInputLang } from "../ui/NewInputLang";
import { useAccountSettings } from "../../contexts/AccountSettingsContext";

export const Treasurysettings = () => {
  const { t } = useTranslation("settings");
  const { getChartAccountLevelLimit } = useAccountSettings();
  const chartLevelLimit = getChartAccountLevelLimit();
  console.log("Treasurysettings - Chart Level Limit:", chartLevelLimit);
  const [langar, setLangar] = useState(true);
  const [treasuryList, setTreasuryList] = useState([]);
  const [bankAccountsList, setBankAccountsList] = useState([]);
  const [treasuryCode, setTreasuryCode] = useState("");
  const [treasuryName, setTreasuryName] = useState("");
  const [treasuryEnName, settreasuryEnName] = useState("");
  const [subAccount, setSubAccount] = useState("");
  const [bankId, setBankId] = useState("");
  const [error, setError] = useState({});
  const [onShow, setOnShow] = useState(false);
  const [selectedTreasuryId, setSelectedTreasuryId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingTreasuryId, setEditingTreasuryId] = useState(null);
  const [treeParent, setTreeParent] = useState([]);
  const [hasFetchedTree, setHasFetchedTree] = useState(false);
  const [accountNamesCache, setAccountNamesCache] = useState({});
  const [isCacheReady, setIsCacheReady] = useState(false);
  const { currentTenantId, currentCompanyId, currentBranchId , currentLangId } = useCurrent();
  const { data, postData, loading } = usePost();
  const { loading: delloading, deleteItem } = useDelete();
  const {
    data: incomesTreasuriesResult,
    loading: loadingTreasuries,
    refreshHandler: refetchTreasuries,
  } = useFetch(
    `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/treasuries/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const {
    data: incomesCountResult,
    loading: loadingCountResult,
    refreshHandler,
  } = useFetch(
    `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/treasuries/count/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const { data: bankAccountsResult } = useFetch(
    `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/banks-accounts/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const {
    data: savedata,
    loading: saveloading,
    error: saveerr,
    putData,
  } = usePut();

  useEffect(() => {
    if (incomesCountResult && !isEditing) {
      setTreasuryCode((parseInt(incomesCountResult?.data) + 1).toString());
    }
  }, [incomesCountResult, isEditing]);

  useEffect(() => {
    if (incomesTreasuriesResult?.data) {
      setTreasuryList(incomesTreasuriesResult.data);
    }
  }, [incomesTreasuriesResult]);

  useEffect(() => {
    if (bankAccountsResult?.data) {
      setBankAccountsList(bankAccountsResult.data);
    }
  }, [bankAccountsResult]);

  // Fetch tree account data (only once)
  useEffect(() => {
    if (currentTenantId && currentCompanyId && !hasFetchedTree) {
      setHasFetchedTree(true);
      postData("https://api.absat-erp.com/acc/tree-account", {
        tenant_id: currentTenantId,
        company_id: currentCompanyId,
      });
    }
  }, [currentTenantId, currentCompanyId, hasFetchedTree]);

  // Update treeParent when data is received and build cache
  useEffect(() => {
    if (data?.data?.treeParent) {
      setTreeParent(data.data.treeParent);
      
      // Build cache for all accounts in the tree
      const buildCache = (tree, cache = {}) => {
        if (!tree || !Array.isArray(tree)) return cache;
        
        tree.forEach(node => {
          cache[node.account_no] = currentLangId === "en" 
            ? (node.name_en || node.name_ar || "")
            : (node.name_ar || node.name_en || "");
          
          if (node.childs && Array.isArray(node.childs)) {
            buildCache(node.childs, cache);
          }
        });
        
        return cache;
      };
      
      const newCache = buildCache(data.data.treeParent);
      setAccountNamesCache(newCache);
      setIsCacheReady(true);
    }
  }, [data, currentLangId]);

  // Get account name from cache
  const getAccountName = (accountNo) => {
    if (!accountNo) return "";
    const extractedNo = typeof accountNo === "string"
      ? accountNo.split("/").pop()?.trim()
      : accountNo;
    return accountNamesCache[extractedNo] || "";
  };

  // Get extracted account number for display
  const getExtractedAccountNo = (item) => {
    const accountNo = item?.account?.account_no || item?.account_no || "";
    return accountNo.includes("/")
      ? accountNo.split("/").pop()?.trim()
      : accountNo;
  };

  // Get sub-account display name (from nested object or cache)
  const getSubAccountName = (item) => {
    if (item?.account?.name_ar || item?.account?.name_en) {
      return currentLangId === "en" ? item?.account?.name_en : item?.account?.name_ar;
    }
    if (item?.account_no) return getAccountName(item?.account_no);
    return "";
  };

  const resolveBankLabel = (treasury) => {
    const bank = treasury?.bank;
    if (bank) {
      return currentLangId === "en" ? bank?.name_en : bank?.name_ar;
    }
    const bankIdValue = treasury?.bank_id;
    if (!bankIdValue) return "";
    const found = bankAccountsList.find(
      (b) => String(b.id) === String(bankIdValue)
    );
    return currentLangId === "en" ? found?.name_en : found?.name_ar;
  };

  const addTreasury = () => {
    let errors = {};

    if (!treasuryCode) errors.code = "Code Is Required";
    if (langar && !treasuryName) {
      errors.name_ar = "Arabic And English Name Is Required";
    }
    if (!langar && !treasuryEnName) {
      errors.name_en = "English And Arabic Name Is Required";
    }


    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    const treasuryData = {
      code: treasuryCode,
      name_ar: treasuryName || "_",
      name_en: treasuryEnName || "_",
      account_no: subAccount,
      ...(bankId ? { bank_id: Number(bankId) } : {}),
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
    };

    const resetForm = () => {
      setTreasuryCode("");
      setTreasuryName("");
      settreasuryEnName("");
      setSubAccount("");
      setBankId("");
      setIsEditing(false);
      setEditingTreasuryId(null);
      setError({});
    };

    if (!isEditing) {
      postData(
        `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/treasuries`,
        treasuryData
      ).then(() => {
        refetchTreasuries();
        refreshHandler();
        resetForm();
      });
    } else {
      putData(
        `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/treasuries/${editingTreasuryId}`,
        treasuryData,
        "settings"
      ).then(() => {
        refetchTreasuries();
        refreshHandler();
        resetForm();
      });
    }
  };

  const deleteTreasury = (id) => {
    deleteItem(
      `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/treasuries/${id}`
    ).then(() => {
      refetchTreasuries();
      refreshHandler();
      setOnShow(false);
    });
  };

  return (
    <>
      {!treasuryCode ? (
        <div className="h-20 w-full justify-center items-center flex">
          <MwSpinnerButton />
        </div>
      ) : (
        <section className="flex flex-col flex-1">
          <ConfirmDelete
            onShow={onShow}
            setOnShow={setOnShow}
            onDeleteHandler={() => deleteTreasury(selectedTreasuryId)}
            loading={delloading}
            msg={t("treasury.treasurydel")}
          />
          <div className="flex justify-end mb-3">
            <NewButton onClick={addTreasury}>
              {loading || saveloading ? (
                <MwSpinnerButton />
              ) : isEditing ? (
                t("general.update")
              ) : (
                <>
                  <IoMdAdd className="text-white text-lg group-hover:text-[#ffffff]" />
                  <p className="">{t("general.Add")}</p>
                </>
              )}
            </NewButton>
          </div>
          <div className="flex flex-col md:flex-row md:flex-nowrap w-full items-end gap-2">
            <div className="w-full md:w-28">
              <MwInputText
                invalid={error?.code}
                disabled={true}
                label={t("treasury.treasurycode")}
                value={treasuryCode}
                onChange={(e) => setTreasuryCode(e.target.value)}
                classNameInput="w-[100%] text-center  flex-1  "
              />
            </div>
            <div className="w-full md:flex-1 md:min-w-64 flex flex-col justify-center">
              <NewInputLang
                invalid={error?.name_ar || error?.name_en}
                placeholder={t("treasury.treasurynameplaceholder")}
                label={t("treasury.treasuryname")}
                value={langar ? treasuryName : treasuryEnName}
                langar={langar}
                onChange={(value) => {
                  if (langar) {
                    setTreasuryName(value);
                  } else {
                    settreasuryEnName(value);
                  }
                }}
                onChangeLang={() => setLangar(!langar)}
                classNameInput="w-[100%] flex-1"
              />
            </div>
            <div className="w-full md:flex-1 md:min-w-72">
              <MwSelectorAccount
                key={isEditing ? `treasury-edit-${editingTreasuryId || "none"}-${subAccount || "empty"}` : "treasury-create"}
                withLabel={true}
                placeholder={t("treasury.treasuryAccount")}
                classNamePrivate="flex-1 w-full"
                invalid={error?.account}
                initialValue={`${subAccount || ""}`}
                onChangeCallback={(selectedAccount) => {
                  setSubAccount(selectedAccount?.account_no || "");
                }}
                levelLimit={chartLevelLimit}
              />
            </div>
            <div className="w-full md:w-52 flex flex-col">
              <label className="text-xs font-[700] px-1 text-[#261759]">
                {t("treasury.bank")}
              </label>
              <select
                value={bankId}
                onChange={(e) => setBankId(e.target.value)}
                className="h-9 bg-white border border-[#8D82B6] border-opacity-55 rounded-md text-sm text-[#251658] px-2"
              >
                <option value="">{t("treasury.bankNone")}</option>
                {bankAccountsList?.map((bank) => (
                  <option key={bank.id} value={bank.id}>
                    {currentLangId === "en" ? bank?.name_en : bank?.name_ar}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {loadingTreasuries && treasuryList?.length === 0 ? (
            <div className="h-40 flex justify-center items-center w-full">
              {" "}
              <MwSpinnerButton />
            </div>
          ) : treasuryList?.length > 0 ? (
            <>
              <>
                <div className="flex w-full mt-3 justify-around bg-[#F2F0FC] p-3 rounded-t-lg font-[800] text-[#251658] text-sm">
                  <div className="w-32 text-center">
                    {t("treasury.treasurycode")}
                  </div>
                  <div className="w-40 text-center">
                    {t("treasury.treasuryname")}
                  </div>
                  <div className="w-48 text-center">
                    {t("treasury.treasuryaccountshow")}
                  </div>
                  <div className="w-40 text-center">{t("treasury.bank")}</div>
                  <div className="w-20 text-center"></div>
                </div>
                <div className="divide-y  ">
                  {treasuryList.map((item, index) => (
                    <div
                      key={index}
                      className="flex w-full border-b border-[#ddd0bf] border-opacity-25 cursor-pointer justify-around items-center p-3 text-[#251658] font-semibold text-sm"
                    >
                      <div className="w-32 text-center">{item?.code}</div>
                      <div className="w-40 text-center">
                        {currentLangId === "en" ? item?.name_en : item?.name_ar}
                      </div>
                      <div className="w-48 text-center">
                        {!isCacheReady && (item?.account_no || item?.account?.account_no) ? (
                          <div className="flex items-center justify-center gap-1">
                            <div className="h-3 w-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-3 w-20 bg-gray-200 rounded animate-pulse" />
                          </div>
                        ) : (
                          (() => {
                            const no = getExtractedAccountNo(item);
                            const name = getSubAccountName(item);
                            if (!no && !name) return <span className="text-gray-400">—</span>;
                            return (
                              <div className="flex items-center justify-center gap-1">
                                {no && (
                                  <span className="text-xs text-gray-500 font-semibold bg-gray-100 px-1.5 py-0.5 rounded">
                                    {no}
                                  </span>
                                )}
                                {no && name && <span className="text-gray-300 text-xs">|</span>}
                                {name && (
                                  <span className="font-semibold text-[#251658] text-xs">
                                    {name}
                                  </span>
                                )}
                              </div>
                            );
                          })()
                        )}
                      </div>
                      <div className="w-40 text-center">
                        {resolveBankLabel(item) || ""}
                      </div>
                      <div className="w-20 flex justify-center items-center gap-2">
                        <button
                          onClick={() => {
                            setIsEditing(true);
                            setEditingTreasuryId(item.id);
                            setTreasuryCode(item.code);
                            setTreasuryName(
                              item.name_ar
                            );
                            settreasuryEnName(item?.name_en)
                            // Extract just the account number from the existing data
                            const accountNo = item?.account_no || item?.account?.account_no || "";
                            // If it's in the old format "Name/Number", extract the number
                            const extractedAccountNo = accountNo.includes('/') 
                              ? accountNo.split('/').pop()?.trim() 
                              : accountNo;
                            setSubAccount(extractedAccountNo);
                            setBankId(String(item?.bank_id ?? item?.bank?.id ?? ""));
                          }}
                          className="text-blue-500 hover:text-blue-700 mx-2"
                        >
                          <img
                            className="w-4"
                            src="/assets/icons/Edit.png"
                            alt="delete"
                            srcSet=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            setSelectedTreasuryId(item.id);
                            setOnShow(true);
                          }}
                          className="text-red-500 hover:text-red-700"
                        >
                          <img
                            className="w-4"
                            src="/assets/icons/Trash.png"
                            alt="delete"
                            srcSet=""
                          />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            </>
          ) : (
            <div className=" h-[calc(100vh-230px)] ">
            <SettingsEmptyState msg="لا يوجد خزائن" />
            </div> 
          )}
        </section>
      )}
    </>
  );
};
